export const VERSION_NAME = 'feature/DEV-postocde-fix';
export const VERSION_HASH = '6021cde99229240545433615166f55dc03a6c47f';
